import axios from 'axios';
import * as ls from '../helpers/localStorage';
import { API_URL } from './api';

export const accountService = {

    get (id) {
        console.log('accountService: get', id);

        return axios
            .get(`${API_URL}/gebruiker/${id}`)
            .then((response) => {
                // check if we get an account
                if (response.data.data)
                {
                    return response.data.data;
                }

                return response;
            });
    },

    user () {
        console.log('accountService: user');

        return axios
            .get(`${API_URL}/gebruiker`)
            .then((response) => {
                // check if we get an account
                if (response.data.data)
                {
                    // store the firstname
                    ls.set('account:firstname', response.data.data.Naam);

                    // store the email
                    ls.set('account:email', response.data.data.Emailadres);

                    return response.data.data;
                }

                return response;
            });
    },

    login (formData) {
        console.log('accountService: login', formData);

        return axios
            .post(`${API_URL}/login`, formData)
            .then((response) => {
                // check if we get a token
                if (response.data.token)
                {
                    // store the token
                    ls.set('account:token', response.data.token);

                    return response.data.token;
                }

                return response;
            });
    },

    register (formData) {
        console.log('accountService: register');

        return axios
            .post(`${API_URL}/registreer`, formData)
            .then((response) => {
                // check if we get a token
                if (response.data.token)
                {
                    // store the token
                    ls.set('account:token', response.data.token);

                    // get the user
                    this.user();
                }

                return response;
            });
    },

    logout () {
        console.log('accountService: logout');

        return axios
            .get(`${API_URL}/logout`)
            .then((response) => {
                // remove the token
                ls.remove('account:token');

                return response;
            });
    },

    passwordEmail (formData) {
        console.log('accountService: passwordEmail');

        return axios
            .post(`${API_URL}/wachtwoord/vergeten`, formData)
            .then((response) => {
                console.log(response);

                return response;
            });
    },

    passwordReset (formData) {
        console.log('accountService: passwordReset');

        return axios
            .post(`${API_URL}/wachtwoord/nieuw`, formData)
            .then((response) => {
                console.log(response);

                return response;
            });
    },

    update (formData) {
        console.log('accountService: update');

        return axios
            .put(`${API_URL}/gebruiker`, formData)
            .then((response) => response);
    },
};

export default accountService;
